
import {Prop, Component, Mixins, Watch} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import TaksitSayisinaGoreTaksitlendirme
  from "@/components/anakart/taksitlendirme/taksitlendirme-tipleri/TaksitSayisinaGoreTaksitlendirme.vue";
import TaksitTutarinaGoreTaksitlendirme
  from "@/components/anakart/taksitlendirme/taksitlendirme-tipleri/TaksitTutarinaGoreTaksitlendirme.vue";
import OzelTaksitlendirme
  from "@/components/anakart/taksitlendirme/taksitlendirme-tipleri/OzelTaksitlendirme.vue";
import TaksitAnaBilgiler from "@/components/anakart/taksitlendirme/TaksitAnaBilgilerForm.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import TaksitlendirmeList from "@/components/lists/TaksitlendirmeList.vue";
import {TaksitHesapAyarEntity} from "@/entity/TaksitHesapAyarEntity";
import {TakipEntity} from "@/entity/TakipEntity";
import {TaksitlendirmeTuru} from "@/enum/TaksitlendirmeTuru";
import TakipDetayService from "@/services/takipDetayService";


@Component({
  components: {
    TaksitlendirmeList,
    FormWrapper,
    TaksitAnaBilgiler,
    OzelTaksitlendirme,
    TaksitTutarinaGoreTaksitlendirme,
    TaksitSayisinaGoreTaksitlendirme
  }
})
export default class TaksitlendirmeForm extends Mixins(ObjectInputMixin) {
  @Prop() genelToplam!: number;

  localValue!: TakipEntity;
  hesapDegerleri!: TaksitHesapAyarEntity;
  TaksitlendirmeTuru!:TaksitlendirmeTuru
  loading=false;
  tab = 0;
  ozelTaksitler:any=[]
  appendMode:boolean=false
  existingBeforeAppend:any[]=[]
  redirectedFromOzel:boolean=false
  currentAbortController:any=null
  wasCleared:boolean=false
  lockOzelTabs:boolean=false
  showSayisiPanel:boolean=false
  showTutarPanel:boolean=false
  addedCount:number=0
  continueFromOzel:boolean=false
  kalanRenderSeed:number=0
  hesaplananTaksit:any

  handleSayisinaGore(number:any){
    // Özel Taksitlendirme'den yönlendirme: sekme değişmeden aynı sekmede panel göster
    if(this.addedCount<=0){
      // Listeye ekleme yapılmadan devam edilemez
      return
    }
    // Önce özel taksit hesapla: sunucu durumunu senkronla, UI'ı kilitle
    this.loading = true
    if(this.currentAbortController){ try{ this.currentAbortController.abort(); }catch(e){} }
    this.currentAbortController = new AbortController();
    // İstek payload zorunlu alanları
    this.localValue.taksit_hesap_ayar.takip_id = this.localValue.id
    this.localValue.taksit_hesap_ayar.taksit_turu = TaksitlendirmeTuru.ozelTaksitlendirme
    // Feragat alanlarını garanti altına al
    if(this.localValue.taksit_hesap_ayar.feragat_var_mi !== true){
      this.localValue.taksit_hesap_ayar.feragat_var_mi = false
      this.localValue.taksit_hesap_ayar.feragat_tutar = 0 as any
    }
    // Diğer zorunlu bayrakları da defaultla
    if(this.localValue.taksit_hesap_ayar.haftasonu_taksit_olmasin !== true){
      this.localValue.taksit_hesap_ayar.haftasonu_taksit_olmasin = false as any
    }
    if(this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi !== true){
      this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi = false as any
    }
    if(!this.localValue.taksit_hesap_ayar.taksitler || this.localValue.taksit_hesap_ayar.taksitler.length===0){
      this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler || []
    }
    const goNext = (resp:any)=>{
      this.localValue.taksit_hesap_ayar = resp.data;
      this.localValue.taksitler = resp.data.taksitler
      this.input()
      // Hesaplandıktan sonra paneli göster ve sekmeyi kilitle
      this.appendMode = false
      this.redirectedFromOzel = true
      this.existingBeforeAppend = this.localValue?.taksitler ? [...this.localValue.taksitler] : []
      this.lockOzelTabs = true
      const isSayisi = Number(number)===0
      this.showSayisiPanel = isSayisi
      this.showTutarPanel = !isSayisi
      // Özel akışından gelindi: son index'i hesap ayara koy
      const lastIdx = this.getLastIndex()
      ;(this.localValue.taksit_hesap_ayar as any).last_index = lastIdx
      this.continueFromOzel = true
      this.$nextTick(()=>{ this.tab = 2 })
    }
    const req = this.$http.put('/api/v1/taksit/ozel-taksit-faiz-hesapla', this.localValue.taksit_hesap_ayar, { signal: (this.currentAbortController as any).signal })
    req.then(response => { goNext(response) })
        .finally(()=>{ this.loading=false; this.currentAbortController=null; })
  }

  handleOzelTaksitler(taksitler:any){
    // Özel Taksitlendirme'den yerel taksitler geldi: listeye ekle, istek atma
    const existing = this.localValue?.taksitler ? [...this.localValue.taksitler] : []
    this.localValue.taksitler = [...existing, ...taksitler]
    if(this.localValue?.taksit_hesap_ayar){
      this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler
    }
    this.input()
    // Kalan tutar görselini anlık güncellemek için re-render tetikle
    this.kalanRenderSeed++
    // En az bir kere eklendiyse sekmeleri Özel'e kilitle
    this.lockOzelTabs = true
    this.tab = 2
    if(Array.isArray(taksitler) && taksitler.length>0){
      this.addedCount += 1
    }
  }
  @Watch('tab')
  onTabChanged(){
    if(this.redirectedFromOzel){
      // Sadece özelden yönlendirmede appendMode açık kalsın
      this.appendMode = true
      this.redirectedFromOzel = false
    }else{
      // Kullanıcı sekmeyi kendi seçtiyse kapat
      this.appendMode = false
      this.existingBeforeAppend = []
    }
  }
  get kalanBorc(){
    const list = this.localValue?.taksitler || [];
    const parseAmount = (val: any) => {
      if (val == null) return 0;
      if (typeof val === 'number') return val;
      if (typeof val === 'string') {
        const cleaned = val.replace(/\s|TL/g, '').replace(/\./g, '').replace(',', '.');
        const num = Number(cleaned);
        return isNaN(num) ? 0 : num;
      }
      return 0;
    };
    const toplamTaksit = list.reduce((sum: number, t: any) => {
      const tutarRaw = t && (t.taksit_tutari != null ? t.taksit_tutari : t.tutar);
      const tutar = parseAmount(tutarRaw);
      return sum + tutar;
    }, 0);
    const esas = Number(this.genelToplam) || 0;
    const feragat = this.localValue?.taksit_hesap_ayar?.feragat_var_mi ? (Number(this.localValue.taksit_hesap_ayar.feragat_tutar) || 0) : 0;
    const kalan = Math.max(esas - toplamTaksit - feragat, 0);
    return kalan;
  }

  get toplamTaksitTutar(){
    const list = this.localValue?.taksitler || [];
    return list.reduce((sum: number, t: any) => sum + (Number(t.tutar)||Number(t.taksit_tutari)||0), 0)
  }

  // TDT-3107: Borçlu id -> isim haritası. Bu ekrana borçlular faiz/kapak verisinden (faizData.data)
  // geldiğinden çoğu zaman yalnızca kisi_id/kurum_id taşır, isim alanı içermez. Adlar önce sayfa
  // açılırken store'a (takipDetay) alınmış borçlu verisinden çözülür (ek istek YOK); store'da da
  // yoksa TÜM borçlular TEK istekle /api/v1/takip/{id}/borclular'dan alınır (tek tek istek atılmaz).
  borcluAdMap: { [id: number]: string } = {};

  // TDT-3107: Dosyadaki borçlular seçim kutusu için {value:id, text:isim} listesi.
  get borcluSecenekleri(){
    const list = (this.localValue && (this.localValue as any).borclular) || [];
    return list.map((b:any) => ({ value: b.id, text: this.borcluAdMap[b.id] || this.borcluAdiniGetir(b) }));
  }

  // Eldeki veriden borçlu adını çöz. Birden çok şekli destekler:
  //  - kisi/kurum ilişkisi (kisiKurumAd)
  //  - /api/v1/takip/{id}/borclular düz şekli: { ad, soyad, sirket_adi }
  //  - borclu_bilgileri (newKisiKurumAdState)
  private borcluAdiniGetir(b: any): string {
    if (!b) return '';
    const adKisiKurum = this.$helper.kisiKurumAd(b);
    if (adKisiKurum && adKisiKurum.trim()) return adKisiKurum.trim();
    const duz = (b.kurum_adi || b.sirket_adi || [b.ad, b.soyad].filter(Boolean).join(' ') || '').trim();
    if (duz) return duz;
    const adState = this.$helper.newKisiKurumAdState(b);
    if (adState && adState.trim()) return adState.trim();
    return 'Borçlu #' + b.id;
  }

  // Borçlu adlarını çöz. Sıra:
  //  (1) borçlunun kendi verisi + store'daki (takipDetay) yüklü borçlu — EK İSTEK YOK.
  //  (2) hâlâ çözülemeyen kalırsa TEK istekle /api/v1/takip/{id}/borclular çağrılır (tek tek DEĞİL).
  private async borcluAdlariniDoldur(){
    const list = (this.localValue && (this.localValue as any).borclular) || [];
    if (!list.length) return;

    // 1) Ek istek atmadan: önce borçlunun kendi verisinden, sonra store'daki (takipDetay) borçludan çöz.
    let storeBorclular: any[] = [];
    try {
      const storeTakip = this.$store.getters['takipDetay/takip'];
      storeBorclular = (storeTakip && storeTakip.borclular) || [];
    } catch (e) { storeBorclular = []; }

    const cozFromKaynak = (b:any, kaynak:any[]): string => {
      let isim = this.borcluAdiniGetir(b);
      if (isim.startsWith('Borçlu #') && Array.isArray(kaynak) && kaynak.length) {
        const sb = kaynak.find((x:any) => Number(x.id) === Number(b.id));
        if (sb) {
          const ad = this.borcluAdiniGetir(sb);
          if (ad && !ad.startsWith('Borçlu #')) isim = ad;
        }
      }
      return isim;
    };

    let cozulemeyenVar = false;
    list.forEach((b:any) => {
      const isim = cozFromKaynak(b, storeBorclular);
      this.$set(this.borcluAdMap, b.id, isim);
      if (isim.startsWith('Borçlu #')) cozulemeyenVar = true;
    });

    // 2) Store'da çözülemeyen kaldıysa: TÜM borçluları TEK istekle çek (tek tek istek ATMA).
    //    Bu endpoint zaten sayfada kullanılan kaynak: { id, ad, soyad, sirket_adi }.
    if (!cozulemeyenVar) return;
    try {
      const takipId = (this.localValue && this.localValue.id) || this.$route.params.id;
      if (!takipId) return;
      const bulk = await TakipDetayService.getBorcluByTakipId(String(takipId));
      if (!Array.isArray(bulk) || !bulk.length) return;
      list.forEach((b:any) => {
        const mevcut = this.borcluAdMap[b.id];
        if (mevcut && !mevcut.startsWith('Borçlu #')) return;
        const sb = bulk.find((x:any) => Number(x.id) === Number(b.id));
        if (sb) {
          const ad = this.borcluAdiniGetir(sb);
          if (ad && !ad.startsWith('Borçlu #')) this.$set(this.borcluAdMap, b.id, ad);
        }
      });
    } catch (e) {}
  }

  // taksit_hesap_ayar backend'den geldiğinde bu alan olmayabilir; Vue 2 reaktivitesi için $set ile garanti et.
  private ensureSecilenBorclular(){
    const ayar:any = this.localValue?.taksit_hesap_ayar;
    if (ayar && typeof ayar !== 'string' && !Array.isArray(ayar.secilen_borclu_idleri)){
      this.$set(ayar, 'secilen_borclu_idleri', []);
    }
  }

  // Kalan tutarı 0 faizle yerel olarak taksitlere böl
  private generateZeroInterestInstallments(kalan: number){
    const items:any[]=[]
    const settings = this.localValue.taksit_hesap_ayar
    const startDate = new Date(settings.taksit_baslangic_tarihi as any)
    const perCount = Number(settings.taksit_periyod_sayisi) || 1
    const isMonth = (settings.taksit_periyodu||'ay') === 'ay'

    let counts = 0
    let amount = 0

    if(this.tab===0){
      // sayısına göre
      counts = Number(settings.taksit_sayisi) || 0
      if(counts<=0) return []
      // eşit böl, son taksit kalanı alsın
      const base = Math.floor((kalan / counts) * 100) / 100
      let totalAssigned = 0
      for(let i=0;i<counts;i++){
        amount = i===counts-1 ? Math.max(kalan - totalAssigned, 0) : base
        totalAssigned += amount
        const d = new Date(startDate)
        if(isMonth) d.setMonth(d.getMonth() + (i*perCount))
        else d.setDate(d.getDate() + (i*7*perCount))
        items.push(this.createZeroInterestItem(d, amount))
      }
    }else if(this.tab===1){
      // tutarına göre
      amount = Number(settings.taksit_tutari) || 0
      if(amount<=0) return []
      counts = Math.floor(kalan / amount)
      let remainder = Math.round((kalan - counts*amount)*100)/100
      const total = counts + (remainder>0?1:0)
      for(let i=0;i<total;i++){
        const val = (i<counts)? amount : remainder
        const d = new Date(startDate)
        if(isMonth) d.setMonth(d.getMonth() + (i*perCount))
        else d.setDate(d.getDate() + (i*7*perCount))
        items.push(this.createZeroInterestItem(d, val))
      }
    }
    return items
  }

  private createZeroInterestItem(date: Date, amount: number){
    return {
      index: (this.localValue.taksitler?.length||0),
      tarih: date.toISOString().slice(0,10),
      tutar: amount,
      faiz_isleyen_gun: 0,
      isleyen_faiz: 0,
      toplam_faiz: 0,
      kalan_ana_para: 0,
      kalan_faiz: 0,
      kalan_borc: 0
    }
  }
  @Watch('localValue.taksit_hesap_ayar')
  onTaksitHesapAyarChange() {
    if (typeof this.localValue.taksit_hesap_ayar == "string") {
      this.localValue.taksit_hesap_ayar = JSON.parse(this.localValue.taksit_hesap_ayar);
      if (this.localValue.taksit_hesap_ayar) {
        this.hesapDegerleri = this.localValue.taksit_hesap_ayar;
        if(!this.wasCleared){
          if (this.localValue.taksit_hesap_ayar.taksit_turu == TaksitlendirmeTuru.taksitSayisi) this.tab = 0;
          else if (this.localValue.taksit_hesap_ayar.taksit_turu == TaksitlendirmeTuru.taksitTutari) this.tab = 1;
          else if (this.localValue.taksit_hesap_ayar.taksit_turu == TaksitlendirmeTuru.ozelTaksitlendirme) this.tab = 2;
        }
      }
    }
    if(!this.localValue.taksit_hesap_ayar.taksitler || this.localValue.taksit_hesap_ayar.taksitler.length === 0){
      this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler;
    }
    this.ensureSecilenBorclular();
  }

  mounted() {
    if (this.localValue.taksit_hesap_ayar && typeof this.localValue.taksit_hesap_ayar == "string") {
      this.localValue.taksit_hesap_ayar = JSON.parse(this.localValue.taksit_hesap_ayar);
      this.hesapDegerleri = this.localValue.taksit_hesap_ayar;
      if (this.localValue.taksit_hesap_ayar.taksit_turu == TaksitlendirmeTuru.taksitSayisi) this.tab = 0;
      else if (this.localValue.taksit_hesap_ayar.taksit_turu == TaksitlendirmeTuru.taksitTutari) this.tab = 1;
      else if (this.localValue.taksit_hesap_ayar.taksit_turu == TaksitlendirmeTuru.ozelTaksitlendirme) this.tab = 2;

    } else {
      this.localValue.taksit_hesap_ayar = new TaksitHesapAyarEntity();
      this.input();
    }
    this.ensureSecilenBorclular();
    this.borcluAdlariniDoldur();
  }

  load() {
    this.$emit('load');
  }

  sifirla() {
    this.localValue.taksitler = [];
    if(this.localValue?.taksit_hesap_ayar){
      this.localValue.taksit_hesap_ayar.taksitler = []
      ;(this.localValue.taksit_hesap_ayar as any).ana_para = Number(this.genelToplam) || 0
      ;(this.localValue.taksit_hesap_ayar as any).isleyen_faiz = 0
      ;(this.localValue.taksit_hesap_ayar as any).toplam_borc = Number(this.genelToplam) || 0
      // input alanlarını temizle
      ;(this.localValue.taksit_hesap_ayar as any).taksit_baslangic_tarihi = null
      ;(this.localValue.taksit_hesap_ayar as any).taksit_sayisi = null
      ;(this.localValue.taksit_hesap_ayar as any).taksit_tutari = null
      ;(this.localValue.taksit_hesap_ayar as any).taksit_periyod_sayisi = 1
      ;(this.localValue.taksit_hesap_ayar as any).taksit_periyodu = 'ay'
      ;(this.localValue.taksit_hesap_ayar as any).feragat_var_mi = false
      ;(this.localValue.taksit_hesap_ayar as any).feragat_tutar = 0
      ;(this.localValue.taksit_hesap_ayar as any).taksit_turu = null
      ;(this.localValue.taksit_hesap_ayar as any).baro_vekalet_pulu_gosterilsin_mi = true
      ;(this.localValue.taksit_hesap_ayar as any).vekalet_suret_harci_gosterilsin_mi = true
      ;(this.localValue.taksit_hesap_ayar as any).pesin_harc_gosterilsin_mi = true
    }
    this.loading = false
    this.wasCleared = true
    this.appendMode = false
    this.existingBeforeAppend = []
    this.lockOzelTabs = false
    this.showSayisiPanel = false
    this.showTutarPanel = false
    this.addedCount = 0
    this.kalanRenderSeed++
    this.continueFromOzel = false
    this.tab = 0
    this.input();
  }

  hesapla() {
    this.loading = true;
    this.localValue.taksit_hesap_ayar.takip_id = this.localValue.id;
    if (!this.localValue.taksit_hesap_ayar.feragat_var_mi){
      this.localValue.taksit_hesap_ayar.feragat_tutar=0
    }
    if(this.localValue.taksit_hesap_ayar.hesaplansin_mi){
      this.localValue.taksit_hesap_ayar.hesaplansin_mi=true
    }else if (!this.localValue.taksit_hesap_ayar.hesaplansin_mi){
      this.localValue.taksit_hesap_ayar.hesaplansin_mi=false
    }
    // Kilitliyken alternatif panel açıksa efektif sekmeyi belirle (appendMode bağımsız)
    let effectiveTab = this.tab
    if(this.lockOzelTabs){
      if(this.showSayisiPanel){ effectiveTab = 0 }
      else if(this.showTutarPanel){ effectiveTab = 1 }
    }
    if (effectiveTab == 0) {
      this.localValue.taksit_hesap_ayar.taksit_turu = TaksitlendirmeTuru.taksitSayisi;
      this.localValue.taksit_hesap_ayar.taksit_tutari = null;

      if (!this.localValue.taksit_hesap_ayar.haftasonu_taksit_olmasin)
        this.localValue.taksit_hesap_ayar.haftasonu_taksit_olmasin = false;
      if (!this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi)
        this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi = false;

      if (!this.localValue.taksit_hesap_ayar.feragat_var_mi)
        this.localValue.taksit_hesap_ayar.feragat_var_mi = false;
      // Hesaplama her zaman kalan tutar üzerinden yapılsın
      this.localValue.taksit_hesap_ayar.ana_para = this.kalanBorc;
      this.input();
      if(this.appendMode){
        const yeni = this.generateZeroInterestInstallments(this.kalanBorc)
        this.localValue.taksitler=[...this.existingBeforeAppend, ...yeni]
        if(this.localValue?.taksit_hesap_ayar){
          this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler
        }
        this.wasCleared=false
        this.appendMode=false
        this.existingBeforeAppend=[]
        this.loading=false
        this.$nextTick(()=> this.input());
      }else{
        if(this.currentAbortController){ try{ this.currentAbortController.abort(); }catch(e){} }
        this.currentAbortController = new AbortController();
        this.$http.post('/api/v1/taksit/hesapla', this.localValue.taksit_hesap_ayar, { signal: (this.currentAbortController as any).signal }).then(response => {
          this.localValue.taksit_hesap_ayar = response.data;
          this.localValue.taksitler=response.data.taksitler
          this.wasCleared=false
          this.input();
        }).finally(() => { this.loading = false; this.currentAbortController=null; });
      }
    } else if (effectiveTab == 1) {
      this.localValue.taksit_hesap_ayar.taksit_turu = TaksitlendirmeTuru.taksitTutari;
      this.localValue.taksit_hesap_ayar.taksit_periyodu = "ay";
      this.localValue.taksit_hesap_ayar.taksit_periyod_sayisi = 1;
      this.localValue.taksit_hesap_ayar.taksit_sayisi = null;
      this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi = false;

      if (!this.localValue.taksit_hesap_ayar.feragat_var_mi)
        this.localValue.taksit_hesap_ayar.feragat_var_mi = false;
      // Hesaplama her zaman kalan tutar üzerinden yapılsın
      this.localValue.taksit_hesap_ayar.ana_para = this.kalanBorc;
      this.input();
      if(this.appendMode){
        const yeni = this.generateZeroInterestInstallments(this.kalanBorc)
        this.localValue.taksitler=[...this.existingBeforeAppend, ...yeni]
        if(this.localValue?.taksit_hesap_ayar){
          this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler
        }
        this.wasCleared=false
        this.appendMode=false
        this.existingBeforeAppend=[]
        this.loading=false
        this.$nextTick(()=> this.input());
      }else{
        if(this.currentAbortController){ try{ this.currentAbortController.abort(); }catch(e){} }
        this.currentAbortController = new AbortController();
        this.$http.post('/api/v1/taksit/hesapla', this.localValue.taksit_hesap_ayar, { signal: (this.currentAbortController as any).signal }).then(response => {
          this.localValue.taksit_hesap_ayar = response.data;
          this.localValue.taksitler=response.data.taksitler
          this.wasCleared=false
          this.input();
        }).finally(() => { this.loading = false; this.currentAbortController=null; });
      }
    } else if (effectiveTab == 2) {
      this.localValue.taksit_hesap_ayar.taksit_turu = TaksitlendirmeTuru.ozelTaksitlendirme;
      this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi = false;
      if (!this.localValue.taksit_hesap_ayar.feragat_var_mi)
        this.localValue.taksit_hesap_ayar.feragat_var_mi = false;

      this.input();
      if(this.localValue.taksitler==undefined){
        this.$http.post('/api/v1/taksit/ozel-taksit-hesapla', this.localValue.taksit_hesap_ayar).then(response => {
          this.localValue.taksit_hesap_ayar = response.data;
          this.localValue.taksitler=response.data.taksitler
          this.input();
        }).finally(() => this.loading = false);
      }else{
        this.$http.put('/api/v1/taksit/ozel-taksit-duzenle', this.localValue.taksit_hesap_ayar).then(response => {
          this.localValue.taksit_hesap_ayar = response.data;
          this.localValue.taksitler=response.data.taksitler
          this.input();
        }).finally(() => this.loading = false);
      }


    }

  }

  hesaplaFromTutar(){
    this.loading = true;
    this.localValue.taksit_hesap_ayar.takip_id = this.localValue.id;
    if (!this.localValue.taksit_hesap_ayar.feragat_var_mi){
      this.localValue.taksit_hesap_ayar.feragat_tutar=0
    }
    this.localValue.taksit_hesap_ayar.taksit_turu = TaksitlendirmeTuru.taksitTutari;
    this.localValue.taksit_hesap_ayar.taksit_periyodu = "ay";
    this.localValue.taksit_hesap_ayar.taksit_periyod_sayisi = 1;
    this.localValue.taksit_hesap_ayar.taksit_sayisi = null;
    this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi = false;
    if (!this.localValue.taksit_hesap_ayar.feragat_var_mi)
      this.localValue.taksit_hesap_ayar.feragat_var_mi = false;
    this.localValue.taksit_hesap_ayar.ana_para = this.getRemainingForContinuation();
    // last_index: sadece özelden devam ediliyorsa gönder
    ;(this.localValue.taksit_hesap_ayar as any).last_index = this.continueFromOzel ? this.getLastIndex() : null
    this.input();
    if(this.currentAbortController){ try{ this.currentAbortController.abort(); }catch(e){} }
    this.currentAbortController = new AbortController();
    this.$http.post(`/api/v1/taksit/hesapla?ozel_taksitlendirme_mi=${this.continueFromOzel}`, this.localValue.taksit_hesap_ayar, { signal: (this.currentAbortController as any).signal }).then(response => {
      this.hesaplananTaksit = response.data;
      // Artık backend mevcut liste ile birleştirip dönüyor; direkt replace et
      this.localValue.taksitler = response.data.taksitler
      if(this.localValue?.taksit_hesap_ayar){
        this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler
      }
      this.continueFromOzel = false
      this.wasCleared=false
      this.input();
    }).finally(() => { this.loading = false; this.currentAbortController=null; });
  }

  hesaplaFromSayisi(){
    this.loading = true;
    this.localValue.taksit_hesap_ayar.takip_id = this.localValue.id;
    if (!this.localValue.taksit_hesap_ayar.feragat_var_mi){
      this.localValue.taksit_hesap_ayar.feragat_tutar=0
    }
    this.localValue.taksit_hesap_ayar.taksit_turu = TaksitlendirmeTuru.taksitSayisi;
    this.localValue.taksit_hesap_ayar.taksit_tutari = null;
    if (!this.localValue.taksit_hesap_ayar.haftasonu_taksit_olmasin)
      this.localValue.taksit_hesap_ayar.haftasonu_taksit_olmasin = false;
    if (!this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi)
      this.localValue.taksit_hesap_ayar.taksit_tutari_yuvarlansin_mi = false;
    if (!this.localValue.taksit_hesap_ayar.feragat_var_mi)
      this.localValue.taksit_hesap_ayar.feragat_var_mi = false;
    this.localValue.taksit_hesap_ayar.ana_para = this.getRemainingForContinuation();
    // last_index: sadece özelden devam ediliyorsa gönder
    ;(this.localValue.taksit_hesap_ayar as any).last_index = this.continueFromOzel ? this.getLastIndex() : null
    this.input();
    if(this.currentAbortController){ try{ this.currentAbortController.abort(); }catch(e){} }
    this.currentAbortController = new AbortController();
    this.$http.post(`/api/v1/taksit/hesapla?ozel_taksitlendirme_mi=${this.continueFromOzel}`, this.localValue.taksit_hesap_ayar, { signal: (this.currentAbortController as any).signal }).then(response => {
      this.hesaplananTaksit = response.data;
      this.localValue.taksitler = response.data.taksitler
      if(this.localValue?.taksit_hesap_ayar){
        this.localValue.taksit_hesap_ayar.taksitler = this.localValue.taksitler
      }
      this.continueFromOzel = false
      this.wasCleared=false
      this.input();
    }).finally(() => { this.loading = false; this.currentAbortController=null; });
  }

  private getRemainingForContinuation(){
    if(this.continueFromOzel){
      const list = this.localValue?.taksitler || []
      if(list.length>0){
        const last = list[list.length-1]
        const val = (last && (last.kalan_borc!=null ? last.kalan_borc : last.kalan_borc_tutar))
        const num = typeof val==='string' ? Number(String(val).replace(/\s|TL/g,'').replace(/\./g,'').replace(',','.')) : Number(val||0)
        if(!isNaN(num) && num>0) return num
      }
    }
    return this.kalanBorc
  }

  private getLastIndex(){
    const list = this.localValue?.taksitler || []
    if(list.length===0) return null
    let maxIdx:number|null = null
    for(const t of list){
      const idx = (t && (t.index!=null ? Number(t.index) : null))
      if(idx!=null && !isNaN(idx)){
        if(maxIdx==null || idx>maxIdx) maxIdx = idx
      }
    }
    return maxIdx
  }

  updatedHesap(data: { index: number | Array<number>, type: string }) {
    if(!this.localValue.taksitler){
      this.sifirla();
    }
    this.$http.put('/api/v1/taksit/hesapla', {...this.localValue.taksit_hesap_ayar, ...data}).then(response => {
      this.localValue.taksit_hesap_ayar = response.data;
      this.localValue.taksitler=response.data.taksitler;
      this.input();
    });
  }

  save() {
    if(!this.localValue.taksitler){
      this.sifirla();
    }
    // hesaplananTaksit yalnızca sayı/tutar hesaplama yollarında set ediliyor; Özel Taksitlendirme
    // akışında undefined kalır. Ayrıca son 'Hesapla'dan sonra borçlu seçimi değişirse stale kalır.
    // Bu yüzden güncel taksit_hesap_ayar'a düş ve son taksitler + borçlu seçimini gövdeye enjekte et.
    const body: any = { ...(this.hesaplananTaksit || this.localValue.taksit_hesap_ayar) };
    if (this.localValue?.taksit_hesap_ayar) {
      body.taksitler = this.localValue.taksitler;
      body.secilen_borclu_idleri = this.localValue.taksit_hesap_ayar.secilen_borclu_idleri || [];
    }
    this.$http.post('/api/v1/takip/' + this.$route.params.id + '/taksit', body).then((response) => {
      this.$emit("onSuccess");
    });
  }
  vazgec(){
    // Vazgeç ile çıkıldığında taksit listesi temizlensin
    if(this.currentAbortController){
      try{ this.currentAbortController.abort(); }catch(e){}
      this.currentAbortController=null
    }
    this.localValue.taksitler = []
    if(this.localValue?.taksit_hesap_ayar){
      // Parse if it's a string to avoid TypeError
      if (typeof this.localValue.taksit_hesap_ayar === "string") {
        this.localValue.taksit_hesap_ayar = JSON.parse(this.localValue.taksit_hesap_ayar);
      }
      this.localValue.taksit_hesap_ayar.taksitler = []
    }
    this.appendMode=false
    this.existingBeforeAppend=[]
    this.input()
    // Diyalog/sayfa kapanışı üst bileşen tarafından yönetiliyorsa olayı yukarı ilet
    this.$emit('onClose')
  }
  beforeDestroy(){
    if(this.currentAbortController){
      try{ this.currentAbortController.abort(); }catch(e){}
      this.currentAbortController=null
    }
  }
}
